var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ps-product--detail ps-product--fullwidth"},[_c('div',{staticClass:"ps-product__header"},[_c('thumbnail-default',{attrs:{"product":_vm.product}}),_vm._v(" "),_c('information-default',{attrs:{"product":_vm.product}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }